import React from "react";

import {
	FormTreeAction,
	formTreeReducer
} from "src/modules/shared/form-explorer/reducer";
import {
	FilteredNode,
	LocalizedNode,
	Node
} from "src/modules/shared/form-explorer/types";
import { useFilteredNodes } from "src/modules/shared/form-explorer/useFilteredNodes";
import { useLocalizedNodes } from "src/modules/shared/form-explorer/useLocalizedNodes";

const emptyState: LocalizedNode[] = [];

export function useState(
	nodes: Node[],
	hasLimitedAccess: boolean,
	query: string
): readonly [FilteredNode[], React.Dispatch<FormTreeAction>] {
	const [nodesA, dispatch] = React.useReducer(formTreeReducer, emptyState);
	const nodesB = useLocalizedNodes(nodes);
	React.useEffect(() => {
		dispatch({ type: "init", payload: { nodes: nodesB } });
	}, [nodesB]);
	const nodesC = useFilteredNodes(nodesA, hasLimitedAccess, query);
	return [nodesC, dispatch];
}
